import { ResourceSample } from "src/api/connectApi/types";
import { CaseJsonSchema } from "src/cases/queries/templates";
import { CaseCreationNode } from "src/constants/NodeDataTypes";
import { createCaseDataTemplate } from "src/datasets/utils";
import { CaseSchemaWithMetadata } from "src/schema/schemaEditor/CaseSchemaEditor";
import { transformTemplateToFlowSchema } from "src/schema/schemaEditor/caseSchemaUtils";
import { logger } from "src/utils/logger";

const SAMPLE_CASE_ID = "12345678-1234-1234-1234-123456789012";

const EMPTY_CASE_SAMPLE: ResourceSample = { name: "Empty case", sample: {} };

export const getSampleReportsForCaseCreationNode = (
  node: CaseCreationNode,
  caseJsonSchema: CaseJsonSchema | undefined,
): ResourceSample[] => {
  const template = node.data.template;
  if (!caseJsonSchema || !template) {
    return [EMPTY_CASE_SAMPLE];
  }

  try {
    const caseSchema = transformTemplateToFlowSchema(caseJsonSchema, {
      templateId: template.id,
      versionId: template.version_id,
      etag: String(template.etag),
    }).properties.case as CaseSchemaWithMetadata;

    const casePropertiesSchema = (caseSchema.properties?.properties ??
      {}) as CaseSchemaWithMetadata;

    const sample: Record<string, unknown> = {
      id: SAMPLE_CASE_ID,
      case_properties: createCaseDataTemplate(casePropertiesSchema),
      additional_inputs: {},
      file_categories: {},
      queue: node.data.assigned_queue?.value ?? "",
      template: {
        id: template.id,
        version_id: template.version_id,
        etag: String(template.etag),
      },
    };

    return [{ name: "Case example", sample }, EMPTY_CASE_SAMPLE];
  } catch (error) {
    logger.warn("Failed to build case sample from template schema", error);
    return [EMPTY_CASE_SAMPLE];
  }
};
